import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import type { Document as RichTextDocument } from '@contentful/rich-text-types'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import RichText from '@segment/matcha/recipes/RichText'

const copy = {
  headingBase: `What is`,
}

interface DefinitionProps {
  categoryName: string
  categoryDefinitions: RichTextDocument
}
const Definition: FC<PropsWithChildren<DefinitionProps>> = ({ categoryName, categoryDefinitions }) => {
  const heading = `${copy.headingBase} ${categoryName}?`
  return (
    <Wrapper>
      <SectionBase variant="noCopy">
        <StyledCopy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2" variant="h2">
              {heading}
            </CopyText.Heading>
            <CopyText.Description tag="div" variant="pLarge">
              <RichText data={categoryDefinitions} />
            </CopyText.Description>
          </CopyTextBase>
        </StyledCopy>
      </SectionBase>
    </Wrapper>
  )
}

export default Definition

const Wrapper = styled.div``

const StyledCopy = styled(Section.Contents)`
  max-width: 844px;
  margin: 0 auto;
`
